export default String.raw`
.sitemap-sections {
    grid-template-columns: 1fr;
    gap: 25px;
}

.sitemap-group-title {
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 6px;
}

.sitemap-links {
    li {
        margin-bottom: 8px;
        
        a {
            font-size: 14px;
            padding: 6px 0;
            line-height: 1.4;
        }
    }
}

@media only screen and (max-width: 480px) {
    
    .sitemap-sections {
        gap: 20px;
    }
    
    .sitemap-group-title {
        font-size: 16px;
        margin-bottom: 12px;
    }

    .sitemap-links {
        li {
            margin-bottom: 8px;
            
            a {
                font-size: 13px;
                padding: 5px 0;
            }
        }
    }
}
`